<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5">删除确认</span>
      </v-card-title>

      <v-card-text>
        此操作将删除该发货信息，是否继续？
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleCancel">取消</v-btn>
        <v-btn color="error" @click="handleDelete" :loading="loading">确定删除</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from '../../../api'
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      currentItem: null
    }
  },
  methods: {
    handleOpen(item) {
      this.currentItem = item
      this.dialog = true
    },
    handleCancel() {
      this.dialog = false
      this.currentItem = null
    },
    async handleDelete() {
      this.loading = true
      try {
        // 调用删除接口
        const resp = await this.$http.post(api.default.rbac.deleteShipmentUrl, {
          shipment_id: this.currentItem.shipment_id || this.currentItem.id
        })
        if (resp.errno === 0) {
          this.$message.success('删除成功！')
          this.dialog = false
          this.currentItem = null
          // 通知父组件刷新
          this.$emit('handleSearch')
        } else {
          this.$message.error('删除失败！')
        }
      } catch (error) {
        this.$message.error('删除失败！')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>